import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Paginator} from 'front-onceforall-core';
import {useUsersStore} from '../UsersStore';
import Row from './row';

function ListView(props) {
  const {state: usersStore} = useUsersStore();

  return (
    <div>
      <table>
        <thead>
          <tr>
            <td><Translate value="user.lastName"/></td>
            <td><Translate value="user.firstName"/></td>
            <td><Translate value="user.email"/></td>
            <td><Translate value="user.phoneNumber"/></td>
            <td><Translate value="user.registrationDate"/></td>
            <td><Translate value="user.role"/></td>
            <td><Translate value="user.sign"/></td>
            <td><Translate value="user.manageProject"/></td>
            <td/>
          </tr>
        </thead>
        <tbody>
          {usersStore.users.map((user, index) => <Row
            key={`organisation-user-${index}`}
            user={user}
            onUnlinkSuccess={props.onUnlinkSuccess}
          />)}
        </tbody>
      </table>
      <Paginator
        totalItems={usersStore.totalCount}
        pageSize={usersStore.pageSize}
        currentPage={props.page}
        onChangePage={props.onPageChange}
      />
    </div>
  );
}

ListView.propTypes = {
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onUnlinkSuccess: PropTypes.func.isRequired
};

export default ListView;
